var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.2mm",
    height: "21.2mm",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-362",
    x: 8.1,
    y: 9.1,
    width: 43.8,
    height: 43.8,
    rx: 10,
    ry: 10,
    transform: "translate(-13.1 30.3) rotate(-45)",
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-372",
    x: 9.7,
    y: 8.4,
    width: 40.6,
    height: 40.6,
    rx: 10,
    ry: 10,
    transform: "translate(-11.5 29.6) rotate(-45)",
    fill: "#f59e00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.6,27.5c-.9-5.3-3.2-3.9-3.2-3.9-.4,0-.9.1-1.1.1-.2,0-.7,0-1.1-.1,0,0-2.3-1.4-3.2,3.9-.2,1.3-2,6.4-.5,6.7,1.3.3,1.1-.2,2.5-5.8.2-.7.2.9.2,2.3,0,.6,0,2.1-.4,3.3-.7,1.9-.9,2.8-1.3,6.3-.1,1,1.9,1.1,2,.3.9-5.3,1.6-6.3,1.9-7.4.2,1,.9,2,1.9,7.4.1.8,2.1.7,2-.3-.4-3.5-.6-4.4-1.3-6.3-.4-1.2-.4-2.8-.4-3.3,0-1.5,0-3,.2-2.3,1.4,5.5,1.2,6,2.5,5.8,1.6-.3-.2-5.4-.5-6.7Z",
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1,29c-.8-4.8-2.9-3.5-2.9-3.5-.4,0-.8.1-1,.1-.2,0-.7,0-1-.1,0,0-2.1-1.3-2.9,3.5-.2,1.2-1.8,5.7-.4,6,1.1.3,1-.2,2.2-5.1.2-.6.2.8.1,2.1,0,.5,0,1.9-.4,3-.6,1.7-.8,2.5-1.1,5.6,0,.9,1.7,1,1.8.3.8-4.8,1.4-5.7,1.7-6.6.2.9.8,1.8,1.7,6.6.1.7,1.9.6,1.8-.3-.3-3.2-.5-3.9-1.1-5.6-.4-1.1-.4-2.5-.4-3,0-1.3,0-2.7.1-2.1,1.2,5,1.1,5.4,2.2,5.1,1.4-.3-.2-4.8-.4-6Z",
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,30.5c-.7-4.2-2.5-3.1-2.5-3.1-.3,0-.7,0-.9.1-.2,0-.6,0-.9-.1,0,0-1.8-1.1-2.5,3.1-.2,1.1-1.6,5-.4,5.3,1,.2.9-.2,1.9-4.5.1-.5.2.7.1,1.8,0,.4,0,1.6-.3,2.6-.5,1.5-.7,2.2-1,4.9,0,.8,1.5.9,1.6.2.7-4.2,1.3-5,1.4-5.7.2.8.7,1.6,1.4,5.7.1.6,1.7.5,1.6-.2-.3-2.8-.5-3.4-1-4.9-.3-1-.3-2.2-.3-2.6,0-1.2,0-2.4.1-1.8,1.1,4.3.9,4.7,1.9,4.5,1.2-.3-.2-4.2-.4-5.3Z",
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,25.3c1.4,0,2.7-1.4,2.8-3,0-.4,0-.8-.1-1.2v-1.3s-.7.1-.7.1h-.1c0-.1-.3-1.4-.3-1.4l-.8.6-.7-1.3-.7,1.3-1-1.3.3,1.5c-.9.5-1.5,1.4-1.5,2.4v.4c.1,1.7,1.4,3,2.8,3ZM27.1,20.3l.4,1.5s0-1,1.3-1,1,.3,1.3.6c0,.2,0,.3.1.5v.3c-.1,1.2-1,2.2-1.9,2.2s-1.8-1-1.9-2.2c-.2-.8.2-1.5.8-1.9Z",
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,23.4c1.6,0,3.1-1.6,3.2-3.5,0-.5,0-.9-.1-1.3l.5-2.2-1.3.8h-.1c0-.1.2-2.4.2-2.4l-1.4,1.6-.8-2.1-1,1.5-1.5-1.9.8,2.8c-1,.5-1.8,1.6-1.8,2.8v.4c.1,1.9,1.6,3.5,3.2,3.5ZM35.9,17.7l.5,1.8s0-1.2,1.5-1.2,1.2.3,1.5.7c0,.2,0,.4.1.6v.3c-.1,1.4-1.1,2.6-2.2,2.6s-2.1-1.2-2.2-2.6c-.2-.9.2-1.7.9-2.2Z",
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,27.2c1.2,0,2.3-1.2,2.4-2.6,0-.3,0-.7,0-1v-1.4c0,0,0,0-.5.2v-.7s-.7.5-.7.5l-.7-.6-.8.5-.5-.3v.5c-.8.4-1.4,1.2-1.4,2.1v.3c0,1.4,1.2,2.6,2.4,2.6ZM18.5,23l.3,1.3s0-.9,1.1-.9.9.2,1.1.5c0,.1,0,.3,0,.4v.2c0,1-.8,1.9-1.6,1.9s-1.5-.9-1.6-1.9c-.1-.6.2-1.2.7-1.6Z",
    fill: "#82368c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeUpIcon);
export default __webpack_public_path__ + "static/media/AgeUpIcon.f9795e5178e8517ce0113419ff56938b.svg";
export { ForwardRef as ReactComponent };